import { Box, Flex, Text, Image } from 'theme-ui';
import React from 'react';

const CoverBodyAdditionalSection = ({
  subHeaderImage,
  subHeader,
  subtitle,
  alignItems,
  renderImageSpace = false,
  alignment,
}) => {
  return (
    <Flex sx={{ width: '100%', justifyContent: 'center', height: '100%', alignItems: 'center' }}>
      <Flex
        sx={{
          flexDirection: 'column',
          alignItems: alignItems ?? 'start',
          pt: ['2.4rem', '4.8rem'],
          width: ['36rem', '66.8rem'],
          textAlign: alignment?.toLowerCase() ?? 'left',
        }}
      >
        {subHeaderImage && subHeaderImage.url ? (
          <Box sx={{ height: '3.2rem', width: 'auto', mb: '2.4rem' }}>
            <Image src={subHeaderImage.url} alt={subHeaderImage.title}></Image>
          </Box>
        ) : (
          renderImageSpace && <Box sx={{ height: '3.2rem', width: 'auto', mb: '2.4rem' }} />
        )}
        <Flex sx={{ flexDirection: 'column', gap: '8px' }}>
          <Text
            sx={{
              fontSize: ['2rem', '2.8rem'],
              letterSpacing: '-0.02em',
              fontWeight: [500, 700],
              margin: 0,
              textTransform: 'uppercase',
            }}
          >
            {subHeader}
          </Text>
          <Text sx={{ fontSize: '1.6rem' }}>{subtitle}</Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default CoverBodyAdditionalSection;
